import { customerPartNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsCustomerPartNumber";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

customerPartNumberStyles.labelText = {
    size: 16,
    css: css`
        margin-right: 4px;
        color: ${getProp("theme.typography.p.color")};
        font-weight: ${TYPOGRAPHY.weight.mediumbold};
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    font-size: ${TYPOGRAPHY.size.smaller};
                    line-height: 16px;
                `,
                css`
                    font-size: ${TYPOGRAPHY.size.smaller};
                    line-height: 16px;
                `,
                css`
                    font-size: ${TYPOGRAPHY.size.smaller};
                    line-height: 16px;
                `,
                null,
                null,
            ])}
    `,
};

customerPartNumberStyles.valueText = {
    size: 16,
    css: css`
        margin-bottom: 5px;
        color: ${getProp("theme.typography.p.color")};
        font-weight: 400;
    `,
};
